import React from 'react'

import './styles.scss'
import PropTypes from 'prop-types'

export default function VideoPlayer ({ title, url, closeVideo, isVisible }) {
  return isVisible ? (
    <div className='video-container' onClick={e => (e.target === e.currentTarget ? closeVideo(false) : null)}>
      <div className='teacher-video'>
        <iframe src={url} title={title} frameBorder='0' allowFullScreen />
      </div>
    </div>
  ) : null
}

VideoPlayer.propTypes = {
  isVisible: PropTypes.bool,
  closeVideo: PropTypes.func,
  url: PropTypes.string,
  title: PropTypes.string
}
